import angular from 'angular';
import moment from "moment";

angular.module('app.core').factory('SubEntity', SubEntity);

export default class SubEntity {
  constructor(subEntity, $translate) {
    this.translate = $translate;
    this.name = subEntity.name;
    this.code = subEntity.code;
    this.type = subEntity.type;
    this.countryCode = subEntity.countryCode;
    this.status = subEntity.status;
    this.state = subEntity.state;
    this.id = subEntity.id;
    this.headOffice = subEntity.headOffice
    this.representativeLastname = subEntity.representativeLastname
    this.representativeFirstname = subEntity.representativeFirstname
    this.diagMainLinkType = subEntity.diagMainLinkType
    this.diagMainLinkValue = subEntity.diagMainLinkValue
    this.diagSecondaryLinkType = subEntity.diagSecondaryLinkType
    this.diagSecondaryLinkValue = subEntity.diagSecondaryLinkValue
    this.relations = subEntity.nbRelation || 0;
    this.legalEntity = subEntity.legalEntity || null;
    this.creationDate = subEntity.creationDate || null;
    this.dmi = subEntity.dmi || null;
    // this.cooperativeId = subEntity.cooperativeId || null
    this.buildAddress(this, subEntity);
    this.buildPdpRe(this,subEntity);
  }
  buildPdpRe(currentObj, subEntity){
    if(subEntity.pdpRe != null){
      currentObj.pdpRe = {
        startDate : subEntity.pdpRe.startDate ? moment(subEntity.pdpRe.startDate).startOf('day') : null,
        endDate : subEntity.pdpRe.endDate ? moment(subEntity.pdpRe.endDate).startOf('day') : null,
        sentToPpf : subEntity.pdpRe.sentToPpf || false,
        migrationCode: subEntity.pdpRe.migrationCode || null,
        complianceStatus: subEntity.pdpRe.complianceStatus || null,
      };
    }
  }
  getCountryLabel() {
    var countryLabel = '';
    if (this.countryCode) {
      countryLabel = this.translate.instant(
        'country.' + angular.lowercase(this.countryCode)
      );
    }
    return countryLabel;
  }

  getNameWithCode() {
      if(this.name) {
          return this.name +' ( '+this.code+' )';
      }
      return ' ( '+this.code+' )';
  }

  getTypeLabel() {
    var typeLabel = '';
    if (this.type) {
      typeLabel = this.translate.instant(
        'kiss_seller.edit.sub_entity.types.' + this.type
      );
    }
    return typeLabel;
  }

  getStatusLabel() {
      var status = ''
        if (this.status) {
            status = this.translate.instant('kiss_seller.edit.sub_entity.statuses.' + this.status);
        }
        return status;
  }

  getAddress() {
    return `${this.address1 ? this.address1 : ''} ${
      this.address2 ? this.address2 : ''
    } ${this.zipCode ? this.zipCode : ''} ${this.city ? this.city : ''}`;
  }

  getPdpReDate(dateType){
      return `${this.pdpRe && this.pdpRe[dateType] ? this.pdpRe[dateType].format('DD/MM/YYYY') : '-'} `
  }

  buildAddress(current, subEntity) {
    current.address1 = subEntity.address1 || null;
    current.address2 = subEntity.address2 || null;
    current.zipCode = subEntity.zipCode || null;
    current.city = subEntity.city || null;
  }
}
